import Layout from "../../../layout";
import LoginContent from "./features/login";
import "../../auth/auth.scss";

const Login = () => {
  return (
    <Layout>
      <main>
        <LoginContent />
      </main>
    </Layout>
  );
};

export default Login;
